export default __webpack_public_path__ + "media/images/wood-52dd83a0d10b254a308fb42457284979.svg";